import React, { useMemo } from 'react'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import { TeamsWithColours } from './RoundResults'
import ResultsTeamLineChart from './charts/ResultsTeamLineChart'
import { reportingPercentage } from '../model/utils/formatters'
import { getYAxisDataV2 } from './charts/yaxis'
import ChartCard from './components/ChartCard'
import { convertRoundDataToPercentages } from './charts/convertRoundDataToPercentages'

interface Props {
  pastRound1: boolean
  teams: TeamsWithColours[]
  returnOnEquity: ModelAPI.Reporting.DataAndPositions
}

const RoundResultsReturnOnEquity: React.FC<Props> = ({
  pastRound1,
  teams,
  returnOnEquity
}) => {
  const data = useMemo(() => convertRoundDataToPercentages(returnOnEquity.data), [returnOnEquity.data])

  const { minValue, maxValue, numberOfTicks, yAxisDp } = getYAxisDataV2({
    isPercentage: true,
    pastRound1,
    data
  })

  return (
    <VerticalGroup full center wide>
      <ChartCard heading='Return On Equity'>
        <ResultsTeamLineChart
          data={data}
          teams={teams}
          formatter={(val: number) => reportingPercentage(val)}
          yAxisFormatter={(val: number) => reportingPercentage(val, yAxisDp)}
          minYAxisvalue={minValue}
          maxYAxisvalue={maxValue}
          numberOfTicks={numberOfTicks}
          teamPositions={returnOnEquity.teamPositions}
        />
      </ChartCard>
    </VerticalGroup>
  )
}

export default RoundResultsReturnOnEquity
